module.exports = __webpack_public_path__ + "img/difficulty.809eaa2c.png";